import {
  FlexColumn,
  FormField,
  TextField,
  formFieldRequiredLabel as requiredLabel,
} from '@elementary/common-ui/components';
import { FormText } from '@elementary/common-ui/components/FormControls/FormControls';
import { ToggleButtonGroup } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import DialogToggleButton from '../../../shared/DialogToggleButton';
import { RoleArnAuth, SecretAccessKeyAuth } from '../../AuthTypeFormFields';

enum GlueAuthMethod {
  SECRET_ACCESS_KEY = 'access_key',
  ROLE_ARN = 'role',
}

const GlueDataCatalogForm = () => {
  const methods = useFormContext();

  const {
    register,
    watch,
    setValue,
    formState: { errors },
  } = methods;

  return (
    <>
      <FormField
        title="Connection name"
        errorMessage={errors.glueConnectionName?.message as string}
      >
        <TextField
          {...register('glueConnectionName', {
            required: requiredLabel,
          })}
          variant="outlined"
          placeholder="Connection name"
          size="large"
        />
      </FormField>

      <FormField
        title="Region"
        errorMessage={errors.glueRegion?.message as string}
      >
        <TextField
          {...register('glueRegion', {
            required: requiredLabel,
          })}
          variant="outlined"
          placeholder="e.g. us-east-1"
          size="large"
        />
      </FormField>

      <FormText>Select authentication method</FormText>

      <ToggleButtonGroup
        value={watch('glueAuthMethod')}
        onChange={(_, val) => {
          setValue('glueAuthMethod', val);
        }}
        fullWidth
        exclusive
      >
        <DialogToggleButton value={GlueAuthMethod.SECRET_ACCESS_KEY}>
          Secret access key
        </DialogToggleButton>

        <DialogToggleButton value={GlueAuthMethod.ROLE_ARN}>
          AWS role ARN
        </DialogToggleButton>
      </ToggleButtonGroup>

      <FlexColumn gap="inherit">
        {watch('glueAuthMethod') === GlueAuthMethod.SECRET_ACCESS_KEY && (
          <SecretAccessKeyAuth
            secretKeyFormKey="glueSecretAccessKey"
            keyIdFormKey="glueAccessKeyId"
            sessionTokenFormKey="glueSessionToken"
          />
        )}

        {watch('glueAuthMethod') === GlueAuthMethod.ROLE_ARN && (
          <RoleArnAuth
            roleArnFormKey="glueRoleArn"
            externalIdFormKey="glueExternalId"
          />
        )}
      </FlexColumn>
    </>
  );
};

export default GlueDataCatalogForm;
